export const getDomain = (includeSubdomain = false) => {
  const { hostname } = window.location;

  if (includeSubdomain) {
    return hostname;
  }

  const parts = hostname.split(".");

  if (parts.length > 2) {
    return parts.slice(-2).join(".");
  }

  return hostname;
};
